<template>
  <div>
    <FilterOverview
      title="Agentur-Dublettenprüfung"
      :showFilterInitially="false"
      :showFilterButton="false"
      @reload="onReload"
    >
      <template #toolbar-left>
        <button
          type="button"
          class="icon-button filter-button d-flex justify-content-center p-0 mr-4"
          :class="{ 'filter-button--aktiv': isAnyFilterApplied }"
          v-b-tooltip.hover.bottom
          title="Filter anpassen"
          @click="showFilter = !showFilter"
        >
          <span class="d-flex align-items-center"><Funnel :size="20" /></span>
        </button>
        <AgenturDublettenConfirmationToolbarBase
          :isParentLoading="isBusy"
        ></AgenturDublettenConfirmationToolbarBase>
        <template v-if="isAnyFilterApplied">
          <div class="subheader-separator subheader-separator-ver mt-4 mb-2 mr-4 bg-gray-300"></div>
          <div
            class="icon-button d-flex align-items-center justify-content-center text-danger"
            @click="onReset"
            v-b-tooltip.hover.bottom
            title="Filter zurücksetzen"
          >
            <FunnelX :size="20" />
          </div>
        </template>
      </template>
      <template #toolbar-right>
        <b-button
          size="sm"
          class="dialog-btn-secondary"
          @click="$bvModal.show('modal-agentur-duplicates-merge')"
        >
          Manuell zusammenführen
        </b-button>
        <AgenturDuplicatesMergeModal></AgenturDuplicatesMergeModal>
      </template>
      <template #table>
        <AgenturDuplicatesOverview
          :showFilter="showFilter"
          @update:showFilter="showFilter = $event"
          @save-filter="onSaveFilter"
          @reset-filter="onReset"
        />
      </template>
    </FilterOverview>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { GET_AGENTUR_DUPLICATES, RESET_FILTER } from '@/core/agenturen/stores/agenturDuplicates.module';
import AgenturDuplicatesOverview from '@/components/agenturen/agentur-duplicates-overview.vue';
import AgenturDublettenConfirmationToolbarBase from '@/components/agenturen/agentur-duplicates-confirmation-toolbar-base.vue';
import AgenturDuplicatesMergeModal from '@/components/agenturen/agentur-duplicates-merge-modal.vue';
import FilterOverview from '@/components/common/filter-overview.vue';
import { Funnel, FunnelX } from 'lucide-vue';

export default {
  name: 'AgenturenDublettenConfirmationView',
  components: {
    AgenturDuplicatesOverview,
    AgenturDublettenConfirmationToolbarBase,
    AgenturDuplicatesMergeModal,
    FilterOverview,
    Funnel,
    FunnelX,
  },
  data() {
    return {
      showFilter: false,
    };
  },
  computed: {
    ...mapState({
      isBusy: state => state.agenturDuplicates.isBusy,
      isAnyFilterApplied: state => state.agenturDuplicates.isAnyFilterApplied,
    }),
  },
  methods: {
    onReset() {
      this.$store.dispatch(RESET_FILTER);
      this.showFilter = false;
    },
    onSaveFilter() {
      this.showFilter = false;
    },
    onReload() {
      this.$store.dispatch(GET_AGENTUR_DUPLICATES);
    },
  },
};
</script>
